import React from 'react';
import {ErrorMessage} from 'formik';

const FormikErrorMsg = ({name}: { name: string }) => {
    return <ErrorMessage name={name} render={msg => <div className='error-message'><i></i>{msg}</div>}/>
};

export default FormikErrorMsg;